@if (prompt.agreement(); as agreement) {
  @if (prompt.state() === 'modal') {
    <div class="modal-overlay">
      <div
        class="modal-container terms-prompt"
        role="dialog"
        aria-modal="true"
        aria-labelledby="terms-prompt-title"
      >
        <div class="modal-header">
          <h2 id="terms-prompt-title">Updated Terms and Conditions</h2>
        </div>
        @if (prompt.error(); as error) {
          <div class="modal-error" role="alert">{{ error }}</div>
        }
        <div class="modal-body">
          <p>
            Please review and accept the Fleet Violation Payment System
            Agreement.
          </p>
          <p class="terms-prompt-meta">
            <span>Version {{ agreement.version }}</span>
            <span
              >Effective Date:
              {{ agreement.effectiveDate | date: 'MMMM d, y' : 'UTC' }}</span
            >
          </p>
          <a routerLink="/terms" target="_blank">Read the full Agreement</a>
        </div>
        <div class="modal-actions">
          <button
            type="button"
            class="btn-secondary"
            (click)="prompt.remindLater()"
          >
            Remind me later
          </button>
          <button type="button" class="btn-primary" (click)="prompt.agree()">
            I agree
          </button>
        </div>
      </div>
    </div>
  } @else if (prompt.state() === 'banner') {
    <div class="terms-banner" role="status">
      <span>Please review and accept the updated Terms and Conditions.</span>
      <button type="button" class="btn-primary" (click)="prompt.review()">
        Review and accept
      </button>
    </div>
  }
}
